/* Applicationwise global constants, independent from configuration */
export class Globals {
  public static readonly GrayScaleUnitOfMeasure: string = 'Gray Scale';
  public static readonly DecimalPlaces: number = 2
}
